import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-branch-modal',
  templateUrl: './branch-modal.component.html',
  styleUrls: ['./branch-modal.component.scss']
})
export class BranchModalComponent implements OnInit {

  isLoading = true;
  Errors = null;
  branches = null;
  mode = null;
  data = null
  Success = null
  companies = null
  states = null
  cities = null

  groupForm = new FormGroup({
    Branch_Code: new FormControl('', Validators.required),
    Branch_Name: new FormControl('', Validators.required),
    company_name: new FormControl('', Validators.required),
    Branch_Address: new FormControl('', Validators.required),
    Telephone_No: new FormControl('', Validators.required),
    Email_Id: new FormControl('', Validators.required),
    Contact_Person: new FormControl('', Validators.required),
    State_id: new FormControl('', Validators.required),
    City_id: new FormControl('', Validators.required),
    Status: new FormControl('', Validators.required),
    id: new FormControl(null, Validators.required),
  });


  constructor(private modal: ModalService, private _snackBar: MatSnackBar, public auth: SettingsService) { }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      Branch_Code,
      Branch_Name,
      company_name,
      Branch_Address,
      Telephone_No,
      Email_Id,
      Contact_Person,
      State_id,
      City_id,
      Status,
      id,
    } = this.groupForm.value;
    this.auth
      .postBranch(
        Branch_Code,
        Branch_Name,
        company_name,
        Branch_Address,
        Telephone_No,
        Email_Id,
        Contact_Person,
        State_id,
        City_id,
        Status,
        id,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;

          if (this.data.success) {
            this.closeModal()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });          }
          else {
            this.Errors = "Not successful, please try again"
            console.log(resSuccess)
          }
          
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }
  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {

    this.auth
      .getCompanies()
      .subscribe(
        (resSuccess) => {

          this.companies = resSuccess
          this.isLoading = false;
          console.log(this.branches)
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      ); 

      this.auth
      .getState()
      .subscribe(
        (resSuccess) => {

          this.states = resSuccess
          this.isLoading = false;
          console.log(this.branches)
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      ); 

      this.auth
      .getCity()
      .subscribe(
        (resSuccess) => {

          this.cities = resSuccess
          this.isLoading = false;
          console.log(this.branches)
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      ); 

    this.auth
      .getBranches()
      .subscribe(
        (resSuccess) => {

          this.branches = resSuccess
          this.isLoading = false;
          console.log(this.branches)
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      );

  }
  addNew() {
    this.mode = "add"
  }
  edit(branch) {
    this.mode = "edit"
    this.groupForm.patchValue({
      id: branch.Id ,
      Branch_Code: branch.Branch_Code,
      Branch_Name: branch.Branch_Name,
      company_name: branch.company_name,
      Branch_Address: branch.Branch_Address,
      Telephone_No: branch.Telephone_No,
      Email_Id: branch.Email_Id,
      Contact_Person: branch.Contact_Person,
      State_id: branch.State_id,
      City_id: branch.City_id,
      Status: branch.Status,
    });
  }

  delete(title) {
    this.auth
      .delSet("/api/geography/country/delete", title.id)
      .subscribe(
        (resSuccess) => {
          this.branches = this.branches.filter(dattum => dattum.id !== title.id)
          this._snackBar.open('Deleted Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        },
        (resErr) => {
          this._snackBar.open('Error try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
  }

}
